import service from 'service';

export const getDatasets = ({ queryKey: [, params] }) => {
  const url = '/cms/dataset';
  return service.get(url, { params });
};

export const addDataset = (code, payload) => {
  const url = `/cms/dataset`;
  return service.post(url, { code, ...payload });
};

export const editDataset = (code, { id, ...payload }) => {
  const url = `/cms/dataset/${id}`;
  return service.put(url, { code, ...payload });
};

export const deleteDataset = (code, uuid) => {
  const url = `/cms/dataset/${uuid}`;
  return service.delete(url);
};

export default {};
